// Фильтрует нежелательные символы из строки для названий
// Оставляет только безопасные символы: все printable ASCII символы (32-126) + кириллица
export const filterAltCodes = (input: string): string => {
  return input
    .split('')
    .filter(char => {
      const charCode = char.charCodeAt(0);

      return (
        (charCode >= 32 && charCode <= 126) ||    // Все printable ASCII символы
        (charCode >= 1040 && charCode <= 1103) || // А-Я, а-я
        charCode === 1025 ||                      // Ё
        charCode === 1105                         // ё
      );
    })
    .join('');
};


export const handleInputChangeWithAltFilter = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  callback: (filteredValue: string) => void
) => {
  const originalValue = event.target.value;
  const filteredValue = filterAltCodes(originalValue);
  
  if (originalValue !== filteredValue) {
    event.target.value = filteredValue;
  }
  
  callback(filteredValue);
};

export const handlePasteWithAltFilter = (
  event: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  currentValue: string,
  callback: (filteredValue: string) => void
) => {
  event.preventDefault();
  
  const pastedText = event.clipboardData.getData('text');
  const filteredPastedText = filterAltCodes(pastedText);
  const target = event.target as HTMLInputElement | HTMLTextAreaElement;
  const start = target.selectionStart || 0;
  const end = target.selectionEnd || 0;
  
  const newValue = currentValue.substring(0, start) + filteredPastedText + currentValue.substring(end);
  const filteredNewValue = filterAltCodes(newValue);
  
  // Учитываем maxLength атрибут
  const maxLength = target.maxLength;
  const finalFilteredValue = maxLength > 0 && filteredNewValue.length > maxLength
    ? filteredNewValue.substring(0, maxLength)
    : filteredNewValue;
  
  target.value = finalFilteredValue;
  
  // Корректируем позицию курсора с учетом возможной обрезки
  const insertedLength = Math.min(filteredPastedText.length, maxLength > 0 ? maxLength - (currentValue.length - (end - start)) : filteredPastedText.length);
  const newCursorPosition = start + insertedLength;
  setTimeout(() => {
    target.setSelectionRange(newCursorPosition, newCursorPosition);
  }, 0);
  
  callback(finalFilteredValue);
};
